import React, { Component } from "react";
import { Route, Routes } from "react-router-dom";
import { BlobServiceClient } from "@azure/storage-blob";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import Layout from "./pages/Layout";
import { cmsAccount, jsonHeaders } from "./components/NavMenu";
import AppRoutes from "./AppRoutes";
import { msalConfig } from "./authConfig";
import "bootstrap-icons/font/bootstrap-icons.css";

export let azureBlobs = [];
export let bmpCount = 0;

const STORAGE_ACCOUNT = "cmstoragerelease";
const msalInstance = new PublicClientApplication(msalConfig);

export default class App extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        const intervalId = setInterval(() => {
            if (cmsAccount) {
                console.log(cmsAccount);
                this.initStorage();
                clearInterval(intervalId);
            }
        }, 100);
    }

    async initStorage() {
        const accountName = STORAGE_ACCOUNT;
        const containerName = this.removeNonAlphanumeric(cmsAccount.company).toLowerCase();

        var requestOptions = {
            method: "GET",
            headers: jsonHeaders,
            redirect: "follow",
        };

        fetch(`/api/images/sastoken`, requestOptions)
            .then((response) => response.json())
            .then((result) => {
                const sasToken = result;
                const blobSasUrl = `https://${accountName}.blob.core.windows.net?${sasToken}`;
                const blobServiceClient = new BlobServiceClient(blobSasUrl);
                this.containerClient = blobServiceClient.getContainerClient(containerName);
                this.listBlobs();
            });
    }

    async listBlobs() {
        let iter = this.containerClient.listBlobsFlat();
        let blobItem = await iter.next();
        bmpCount = 0;
        while (!blobItem.done) {
            const blobName = blobItem.value.name;
            if (blobName.endsWith(".jpg")) {
                this.downloadBlob(blobName);
                bmpCount++;
            }
            blobItem = await iter.next();
        }
        console.log(bmpCount);
    }

    async downloadBlob(blobName) {
        const blobClient = this.containerClient.getBlockBlobClient(blobName);
        const response = await blobClient.download();
        const blob = await response.blobBody;
        const img = new Image();
        img.src = URL.createObjectURL(blob);
        img.onload = () => {
            const imgObj = {
                imageSrc: img.src,
                name: blobName,
                orientation: img.width >= img.height ? "Landscape" : "Portrait",
            };
            azureBlobs.push(imgObj);
        };
    }

    removeNonAlphanumeric(input) {
        return input.replace(/[^a-zA-Z0-9]/g, "");
    }

    render() {
        return (
            <MsalProvider instance={msalInstance}>
                <Layout>
                    <Routes>
                        {AppRoutes.map((route, index) => {
                            const { element, ...rest } = route;
                            return <Route key={index} {...rest} element={element} />;
                        })}
                    </Routes>
                </Layout>
            </MsalProvider>
        );
    }
}
